// src/config.js — lectura única de variables de entorno.
//
// Vite expone variables al cliente con el prefijo VITE_. La service_role
// (sin prefijo) nunca llega acá: solo se usa en scripts locales y Edge
// Functions de Supabase, ver CLAUDE.md §5.1.
//
// Fail-fast: si faltan variables, el bundle no debería levantar. Mejor un
// error claro al cargar que un createClient() silencioso que después tira
// 401 contra Supabase y confunde el debugging.

export const SUPABASE_URL      = import.meta.env.VITE_SUPABASE_URL
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error(
    '[config] Faltan variables de entorno de Supabase. ' +
    'Revisar .env local (DEV) o variables del hosting (PROD). ' +
    'Ver .env.example en la raíz del repo.'
  )
}
